<template>
  <v-card class="pr-4 pl-4 pr-md-12 pl-md-12">
    <v-card-title primary-title>
      <div class="text-h4">
        Sök buntinnehåll
      </div>
      <v-spacer />         
    </v-card-title>      
    <v-row align="center">
      <v-col cols="10" md="4">
        <v-text-field v-model="bundleId" label="Bunt id" outlined @keyup.enter="search()">
          <template v-slot:append-outer>
            <v-btn icon
                   @click="search()"
            >              
              <v-icon>mdi-magnify</v-icon>                              
            </v-btn>
          </template>
        </v-text-field>
      </v-col>      
    </v-row>

    <v-row>
      <v-col cols="12">
        <Bundle v-if="isSet" :bundle="bundle" />
        <v-alert v-show="message !== ''" color="primary lighten-1" dark class="text-h5">
          {{ message }}
        </v-alert>
      </v-col>      
    </v-row>
  </v-card>  
</template>


<script>
import api from '@/backend/api'
import { isEmpty } from 'lodash'
import Bundle from '@/components/Bundle'

export default {
  name:'SearchBundle',
  components:{Bundle},
  data(){
    return {
      bundleId:undefined,
      bundle:{},
      message:''
    }
  },
  computed:{
    isSet(){
      return !isEmpty(this.bundle)
    }
  },
  methods:{

    search(){
      this.message = ''
      api.getBundle(this.bundleId).then(resp=>{
        this.bundle = resp.data
      }).catch( err=>{
          this.bundle = {}          
          let bunt = this.bundleId
          this.bundleId = undefined
          if(err.response.status === 404){
            this.message = 'Kan inte hitta bunt med id ' + bunt 
           }
        } )
    }
  }

}
</script>